/**
 * Biopet Professional — aliases to page-4 calculation helpers.
 */
import {
  BIOPET_ESSENTIAL_SPECIES_GROUPS as BIOPET_ESSENTIAL_SPECIES_GROUPS_BASE,
  BIOPET_ESSENTIAL_PAGE4_POSITION as BIOPET_ESSENTIAL_PAGE4_POSITION_BASE,
  BIOPET_BAR_GRADIENT_PALETTE as BIOPET_BAR_GRADIENT_PALETTE_BASE,
  getBiopetAgeStage as getBiopetAgeStageBase,
  evaluateBiopetEssentialRow as evaluateBiopetEssentialRowBase,
  buildBiopetEssentialPage4Results as buildBiopetEssentialPage4ResultsBase,
  buildQuartileBySpeciesFromGrids as buildQuartileBySpeciesFromGridsBase
} from '../biopet_essential/calculate_biopet_essential';

export const BIOPET_PROFESSIONAL_SPECIES_GROUPS = BIOPET_ESSENTIAL_SPECIES_GROUPS_BASE;
export const BIOPET_PROFESSIONAL_PAGE4_POSITION = BIOPET_ESSENTIAL_PAGE4_POSITION_BASE;
export const BIOPET_PROFESSIONAL_BAR_GRADIENT_PALETTE = BIOPET_BAR_GRADIENT_PALETTE_BASE;
export const getBiopetProfessionalAgeStage = getBiopetAgeStageBase;
export const evaluateBiopetProfessionalRow = evaluateBiopetEssentialRowBase;
export const buildBiopetProfessionalPage4Results = buildBiopetEssentialPage4ResultsBase;
export const buildQuartileBySpeciesFromGrids = buildQuartileBySpeciesFromGridsBase;

// Backward-compatible aliases
export const BIOPET_ESSENTIAL_SPECIES_GROUPS = BIOPET_PROFESSIONAL_SPECIES_GROUPS;
export const BIOPET_ESSENTIAL_PAGE4_POSITION = BIOPET_PROFESSIONAL_PAGE4_POSITION;
export const getBiopetAgeStage = getBiopetProfessionalAgeStage;
export const evaluateBiopetEssentialRow = evaluateBiopetProfessionalRow;
export const buildBiopetEssentialPage4Results = buildBiopetProfessionalPage4Results;
